import { BASE_URL } from "../constants";
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  // headers: { "Access-Control-Allow-Origin": "*" },
});

export const encodeData = (data) => {
  return Object.keys(data)
    .map((key) => `${key}=${encodeURIComponent(data[key])}`)
    .join("&");
};

axiosInstance.interceptors.request.use((config) => {
  if (sessionStorage.getItem("selectedPublisherId")) {
    config.headers["SelectedPublisherId"] = sessionStorage.getItem(
      "selectedPublisherId"
    );
  }
  return config;
});

// axiosInstance.interceptors.response.use(
//   (response) => response
//   // (error) => {
//   //   Promise.reject(
//   //     (error.response && error.response.data) || "Something went wrong"
//   //   );
//   // }
// );

export default axiosInstance;
